import { FormSectionSimple } from 'components/layout/Section/FormSectionSimple';
import { NsKey } from 'enums/NsKey';
import { InputFactory } from 'factories/InputFactory';
import { naturalPersonLayoutFieldsDisabledRules } from './layout-config/naturalPersonLayoutConfig';
import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { NaturalPersonFormFieldNames } from 'features/new-actor/enums/naturalPersonFormFieldNames';
import { PersonalInformationFieldNames } from 'features/new-actor/enums/personalInformationFieldNames';
import { naturalPersonInputsConfig } from 'features/new-actor/form/inputs-config/naturalPersonInputsConfig';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseLayoutProps } from 'types/form/baseLayoutProps';

export const NaturalPersonLayout: React.FC<BaseLayoutProps> = ({ isEdit, layoutVariant }) => {
  const { t } = useTranslation(NsKey.ActorForm);

  const disabledFields = useMemo(() => {
    return naturalPersonLayoutFieldsDisabledRules[layoutVariant]
  }, [layoutVariant])

  const renderField = useCallback((fieldName: any) => {
    return (
      <InputFactory config={naturalPersonInputsConfig} fieldName={fieldName} disabledFields={isEdit ? disabledFields : undefined} />
    );
  }, [disabledFields, isEdit]);

  return (
    <div className="font-lato flex flex-col gap-4">
      <FormSectionSimple title={t('ACTOR_FORM.LABELS.CONTACT_SECTION')}>
        <>
          <div className="w-full col-span-6 flex gap-4">
            <div className="w-32">
              {renderField(PersonalInformationFieldNames.Civility)}
            </div>
            <div className="flex-grow">
              {renderField(PersonalInformationFieldNames.LastName)}
            </div>
          </div>
          <div className="col-span-3">
            {renderField(PersonalInformationFieldNames.FirstName)}
          </div>
          <div className="col-span-3">
            {renderField(PersonalInformationFieldNames.BirthName)}
          </div>
          <div className="col-span-3">
            {renderField(PersonalInformationFieldNames.BirthCountry)}
          </div>
          <div className="col-span-3">
            {renderField(PersonalInformationFieldNames.Nationality)}
          </div>
          <div className="col-span-3">
            {renderField(PersonalInformationFieldNames.BirthDate)}
          </div>
          <div className="col-span-3">
            {renderField(PersonalInformationFieldNames.Email)}
          </div>
          <div className="col-span-3">
            {renderField(PersonalInformationFieldNames.Phone)}
          </div>
          <div className="col-span-3">
            {renderField(NaturalPersonFormFieldNames.TaxResidenceCountryId)}
          </div>
          <div className="col-span-3">
            {renderField(PersonalInformationFieldNames.IsPPE)}
          </div>
          <div className="col-span-3">
            {renderField(PersonalInformationFieldNames.IsFPE)}
          </div>
        </>
      </FormSectionSimple>
      <FormSectionSimple title={t('ACTOR_FORM.LABELS.COORDINATE_SECTION')}>
        <>
          <div className="col-span-3">
            {renderField(AddressFormFieldNames.Address)}
          </div>
          <div className="col-span-3">
            {renderField(AddressFormFieldNames.AdditionalAddress)}
          </div>
          <div className="col-span-3">
            {renderField(AddressFormFieldNames.PostalCode)}
          </div>
          <div className="col-span-3">
            {renderField(AddressFormFieldNames.City)}
          </div>
          <div className="col-span-3">
            {renderField(AddressFormFieldNames.Country)}
          </div>
        </>
      </FormSectionSimple>
    </div>
  );
};
